import 'jquery';
import 'select2';

export const bindClearButton = ({ clearButton, dropdowns }) => {
  clearButton.click((e) => {
    e.preventDefault();
    dropdowns.val(null).trigger(`change`);
    const [ rootUrl, searchParams ] = window.location.href.split(`?`);
    if (searchParams) {
      window.location.replace(rootUrl);
    }
  });
};

export const bindSearchDropdowns = ({ dropdowns }) => {
  dropdowns.select2({ allowClear: true, width: `100%`, tags: [], tokenSeparators: [ `,`, `, `, ` ` ] });
};

export const bindDateInputs = ({ dateInputs }, options) => {
  dateInputs.datepicker(options);
};
